import React from "react";
import { MdRecommend } from "react-icons/md";
import ContentTitle from "./ContentTitle";
import ThoughtSlider from "./ThoughtSlider";
export default function Thoughts() {
  return (
    <>
      <ContentTitle title={"Thoughts about me"} />
      <ThoughtSlider />
      <div className="text-center mb-3">
        <a className="btn btn-outline-primary" href="https://www.linkedin.com/in/mdalamincse/" target={'_blank'} rel="noreferrer">

     
          Send recommendation
          <MdRecommend />
       
        </a>
       
      </div>
    </>
  );
}
